import {Arg, EasyArg} from "@psdk/frame-father";

export abstract class BasicCPCLArg<T extends BasicCPCLArg<any>> extends EasyArg<string> {
  append(arg: Arg<string>): T {
    super.append(arg);
    return this as unknown as T;
  }

  prepend(arg: Arg<string>): T {
    super.prepend(arg);
    return this as unknown as T;
  }
}
